import { datesComparator } from '@/utils/Dates';
import { getEditableColumn } from '@/utils/Columns';
import { getNodesData } from '@/utils/Table';
import { formatBytes } from '@/utils/File';

// check errors on fields
export const checkErrors = (t,table,api,node,modal,fields,data,sendMessage,action,startEdit = false) => {

    var errors = {};

    let keys;
    if(data){                
        
        keys = Object.keys(fields);

        keys?.map((field) => {      

            var config = fields[field];

            // check required fields
            if(config?.required){
                
                if(
                    (!data || !Object.hasOwn(data,field)) ||
                    data[field] === null || 
                    typeof data[field] === 'undefined' ||
                    (!config?.type && data[field].length === 0)
                ){        
                    errors[field] = t('error.empty');
                }
                else{

                    switch(config.type){

                        case 'text':
                            if(data[field].length === 0){
                                errors[field] = t('error.empty');
                            }
                            break;

                        case 'dropdown_search':
                            if(data[field] === 0 || data[field] === ''){
                                errors[field] = t('error.empty');
                            }
                            break; 

                        case 'dropdown_multiple':
                            if(data[field].length === 0){
                                errors[field] = t('error.empty');
                            }
                            break;  

                        case 'datetime':
                        case 'date':     
                        case 'hour':               
                        case 'datetime_offset':
                            if(data[field] === '0000-00-00 00:00:00' || data[field] === '0000-00-00' || data[field] === false){
                                errors[field] = t('error.empty');
                            }
                            break;   

                        case 'file':
                            var validFiles = data[field]?.filter(item => !item?.delete);
                            if(validFiles?.length === 0){
                                errors[field] = t('error.empty');
                            }
                            break;                     

                        default:
                            if(data[field] === ''){
                                errors[field] = t('error.empty');
                            }
                            break;                      
                    }
                }
            }

            // check other things
            switch(config.type){

                case 'file':
                    
                    if(data && Object.hasOwn(data,field) && Array.isArray(data[field])){

                        var files = data[field]?.filter(item => !item?.delete);

                        // check if max property and overpassed
                        // if no max property, no limit
                        if(
                            config?.simple ||
                            (Object.hasOwn(config,'max') && config?.max !== null && typeof config.max !== 'undefined')
                        ){
    
                            var numFiles = files?.length;
                            var maxInt = parseInt(config?.simple ? 1 : config.max);

                            if(numFiles > maxInt){
                                errors[field] = t('file.errors.max')+' (max: '+maxInt+')';
                            }
                        }

                        // check file sizes (regarding only files to upload)
                        if(Object.hasOwn(config,'size') && config?.size !== null && typeof config.size !== 'undefined'){                           
                            
                            if(files && files?.length > 0){                                
                                
                                files?.forEach((item) => {

                                    if(item?.upload && item?.upload?.size > config.size){

                                        if(!Object?.hasOwn(errors,field)){
                                            errors[field] = {};
                                        }
                                        
                                        errors[field][item.upload?.name] = t('file.errors.size')+' (max: '+formatBytes(config.size)+')';                                        
                                    }
                                });
                            }
                        }

                        // check if total size to upload exceeded (regarding only new files to upload)
                        if(Object.hasOwn(config,'sizetotal') && config?.sizetotal !== null && typeof config.sizetotal !== 'undefined'){

                            var sumTotal = files.reduce((acc, item) => {
                                if(item?.upload && item?.upload?.size){
                                    return acc + item.upload.size;
                                }
                                else{
                                    return 0;
                                }

                            }, 0);
                            
                            if(sumTotal > config?.sizetotal){
                                errors[field] = t('file.errors.sizetotal')+' (max: '+formatBytes(config.size)+')';
                            }
                        }
                        
                    }

                    break;
            }

        });

        let compare;
        switch(table){

            case 'planifications':
                // cannot use a plan that is already used on another planification

                // instead of rows, we use the updated nodes because some rows maybe were updated/deleted/etc.
                var rows = getNodesData(api);

                var planUsed = rows?.filter(row => row?.id !== data['id'] && row?.plan_id === data['plan_id']);
                if(planUsed && planUsed?.length > 0){
                    errors['plan_id'] = t(table+'.errors.planUsed');
                }
                break;

            case 'planification_restrictions':

                // date_limit cannot be before date_required
                if(data['date_required'] && data['date_limit']){
                    compare = datesComparator(data['date_required'],data['date_limit']);
                    
                    if(compare === -1){
                        errors['date_limit'] = t(table+'.errors.dateBefore',{date: t(table+'.fields.date_required')});
                    }
                }

                // date_closure cannot be before date_required
                if(data['date_required'] && data['date_closure']){
                    compare = datesComparator(data['date_required'],data['date_closure']);
                
                    if(compare === -1){
                        errors['date_closure'] = t(table+'.errors.dateBefore',{date: t(table+'.fields.date_required')});
                    }
                }
                break;

            case 'planification_activities':

                // date_end cannot be before date_ini   
                if(data['date_ini'] && data['date_end']){             

                    compare = datesComparator(data['date_ini'],data['date_end']);
                    
                    if(compare === -1){
                        errors['date_end'] = t(table+'.errors.dateBefore',{date: t(table+'.fields.date_ini')});
                    }
                }

                // completed cannot be more than total
                if(data['completed'] && data['total']){             

                    if(data['completed'] > data['total']){
                        errors['completed'] = t(table+'.errors.greater',{field1: t(table+'.fields.completed'),field2: t(table+'.fields.total')});
                    }
                }
                break;

            case 'tickets':
                // if open ticket, it can only have status working or waiting for customer
                // if closed ticket, it can only have statuses resolved, unresolved, cancelled

                // if ticket_status_id is null, it means we are customer, so field not visible and not editable
                if(data['ticket_status_id']){
                    
                    const openStatuses = [1,2];
                    const closedStatuses = [3,4,5,6];
                    
                    if(data['open']){
                        if(!openStatuses.includes(data['ticket_status_id'])){
                            errors['ticket_status_id'] = t(table+'.errors.openStatuses');
                        }
                    }
                    else{
                        if(!closedStatuses.includes(data['ticket_status_id'])){
                            errors['ticket_status_id'] = t(table+'.errors.closedStatuses');
                        }
                    }
                }

                // if field to assign user, cannot be empty
                if(Object.hasOwn(data,'user_id')){
                    if(!data['user_id']){
                        errors['user_id'] = t(table+'.errors.user');
                    }
                }

                break;
        }
    }

    // show message with the errors
    //let errorColumn;
    if(errors && Object.keys(errors)?.length > 0){

        // to place the focus on it if inline edition
        //errorColumn = null;

        var errorTextMessage = t('error.list')+'\n\n';
        var errorTextField = '';

        keys = Object.keys(errors);            
        /*
        if(keys){
            errorColumn = keys[0];
        } 
        */           

        keys?.map((key) => {

            errorTextMessage += ' - '+t(table+'.fields.'+key)+': ';
            errorTextField = '';

            var error = errors[key];

            if(Array.isArray(error)){                
                errorTextMessage += '\n'+error.join('\n')+'\n';
                errorTextField += error.join(' | ');
            }
            else{
                if(typeof error === 'object'){
                    
                    if(Object?.keys(error)){

                        var errorArrayMessage = [];
                        var errorArrayField = [];
                        Object.keys(error)?.forEach((errorKey) => {
                            errorArrayMessage.push('['+errorKey+'] '+error[errorKey]);
                            errorArrayField.push('['+errorKey+'] '+error[errorKey]);
                        });

                        if(errorArrayMessage && errorArrayMessage?.length > 0){
                            errorTextMessage += '\n'+errorArrayMessage.join('\n')+'\n';
                        }

                        if(errorArrayField && errorArrayField?.length > 0){
                            errorTextField += errorArrayField.join(' | ');
                        }
                    }
                }
                else{          
                    errorTextMessage += error+'\n';
                    errorTextField += error;
                }
            }

            errors[key] = errorTextField;
        });

        sendMessage(errorTextMessage,'error');

        // if inline edition        
        if(!modal){

            // check if first column with error is editable
            // if not, get closest one
            var colKeyEdit = getEditableColumn(api,keys[0]);

            if(action === 'enter' || action === 'save'){

                // if adding row and error, set null the id
                const id = data?.id;
                if(!id){
                    node?.setDataValue('id',null);
                }
                
                setTimeout(() => {                  
                    
                    // start edit if coming from mouse event exiting from current row
                    if(startEdit){
                        
                        api?.startEditingCell({
                            rowIndex: node?.rowIndex,
                            colKey: colKeyEdit
                        });

                        // select and focus on the row                  
                        node.setSelected(true);

                        api?.setFocusedCell({
                            rowIndex: node?.rowIndex,
                            colKey: colKeyEdit
                        });
                    }

                    // it does not work if we don't do first startEditingCell
                    // but if doing that, it executes stopEditing first and we don't want to save until 
                    // we check errors
                    /*
                    api?.setFocusedCell({
                        rowIndex: node?.rowIndex,
                        colKey: colKeyEdit
                    });
                    */

                },0);
            }
        }
    }

    return errors;
}

// to check password conditions
export const checkPasswordConditions = (password, minLength = 8, specialCharRequired = false) => {

    const errors = {};
    
    // Regex for specific conditions
    const regex = {
        uppercase: /[A-Z]/,
        lowercase: /[a-z]/,
        number: /\d/        
    };
    
    try {
        const results = {            
            length: password.length >= minLength,
            uppercase: regex.uppercase.test(password),
            lowercase: regex.lowercase.test(password),
            number: regex.number.test(password)
        };

        // Add the special character check only if required
        if(specialCharRequired){
            // Common special characters list
            const regExpSpecialChar = /[!@#$%^&*()\-_=+{};:,<.>?]/;
            results.specialChar = regExpSpecialChar.test(password);
        }

        // Iterate through the results to build the errors object
        for(const key in results){
            if(!results[key]){                
                errors[key] = key;
            }
        }
    }
    catch(error){
        if(error){
            // Log the error in the console (important in a client-side app)
            //console.error("Password validation error:",error);
            
            // Return a generic error, similar to the PHP code's fallback
            errors['passwordconditions'] = 'passwordconditions';
        }
    }

    return errors;
}

// to create the error message from errors array
export const getErrorMessage = (t,element,errors,title = true, fields = true) => {

    var errorText = '';
    if(title){
        errorText = t('error.list')+'\n\n';
    }

    const keys = Object.keys(errors);            

    let error;
    keys?.map((key) => {

        // if generic error and there is no specific error for it
        if(t(element+'.errors.'+errors[key]) === element+'.errors.'+errors[key]){
            error = t('error.'+errors[key]);
        }
        else{
            error = t(element+'.errors.'+errors[key]);
        }
        
        if(fields){
            if(t(element+'.fields.'+key) === element+'.fields.'+key){
                errorText += ' - '+key+': '+error+'\n';
            }
            else{
                errorText += ' - '+t(element+'.fields.'+key)+': '+error+'\n';
            }
        }
        else{
            errorText += ' - '+error+'\n';
        }
    });

    return errorText;
}

// to check typical errors, not empty, etc.
export const checkInputErrors = (data,fieldsNotEmpty = [],fieldsOneMustBeNotEmpty = []) => {

    const errors = {};

    if(data){

        if(fieldsNotEmpty && fieldsNotEmpty?.length > 0){
            fieldsNotEmpty?.forEach((fieldNotEmpty) => {
                if(Object?.hasOwn(data,fieldNotEmpty) && !data[fieldNotEmpty]){
                    errors[fieldNotEmpty] = 'empty';
                }

            });
        }

        if(fieldsOneMustBeNotEmpty && fieldsOneMustBeNotEmpty?.length > 0){
            
            fieldsOneMustBeNotEmpty?.forEach((fieldsOneMustBeNotEmptyGroup) => {

                if(fieldsOneMustBeNotEmptyGroup && fieldsOneMustBeNotEmptyGroup?.length > 0){

                    var valid = false;
                    fieldsOneMustBeNotEmptyGroup?.forEach((fieldOneMustBeNotEmptyGroup) => {

                        if(valid){
                            return;
                        }

                        if(Object?.hasOwn(data,fieldOneMustBeNotEmptyGroup) && data[fieldOneMustBeNotEmptyGroup]){
                            valid = true;                        
                        }

                    });

                    if(!valid){
                        errors[fieldsOneMustBeNotEmptyGroup[0]] = 'empty';
                    }
                }

            });
        }
    }

    return errors;
}